<template>
    <div :style="cssProps">
        <div class="title-textarea">
            {{ title }}<font-awesome-icon v-if="rules.required" :icon="['fas', 'circle']" class="icon-font" />
        </div>
        <div class="textarea-component">
            <textarea
                :disabled="disabled"
                :v-model="value"
                :value="value"
                v-on:input="$emit('input', $event.target.value)"
                :placeholder="placeholderText"
                class="browser-default text-area"
                :style="`background-color: ${disabled ? '#F2F2F2' : backgroundColor};
                    color:${disabled ? '#A5A5A5' : 'none'};
                    width: ${width};
                    height:${height};`"
                @focus="focusInput"
                @blur="focusInput(), validate(), $emit('onblur')"
            >
            </textarea>
        </div>
        <transition name="slide-fade">
            <p style="color: red" v-if="show">{{ messageError }}</p>
        </transition>
    </div>
</template>

<script>
import { validateInput } from '@/utils/rules/input';
export default {
    props: {
        valid: {
            type: Boolean,
            defoult: false
        },
        disabled: {
            type: Boolean,
            defoult: false
        },
        title: {
            type: String,
            default: 'Descrição'
        },
        height: {
            type: String,
            default: '150px'
        },
        width: {
            type: String,
            default: '100%'
        },
        rules: {
            type: Object,
            default: () => ({})
        },
        placeholderText: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        backgroundColor: {
            type: String,
            default: '#FFF'
        },
        focusColor: {
            type: String,
            default: '#a5a5a5'
        }
    },
    methods: {
        focusInput() {
            this.focus.color = this.show ? 'red' : this.focusColor;
            if (this.focus.target) {
                this.focus.target = false;
            } else {
                this.focus.target = true;
            }
        },
        validate() {
            if (!Object.keys(this.rules).length) {
                return false;
            }
            this.messageError = validateInput(this.rules, this.value);
            if (this.messageError.trim('').split('').length) {
                this.focus.color = 'red';
                this.show = true;
            } else {
                this.focus.color = '';
                this.show = false;
            }
            this.$emit('valid', !this.show);
        }
    },
    computed: {
        cssProps() {
            return {
                '--colorInput': this.show ? 'red' : this.focusColor,
                '--colorCircle': this.show ? 'red' : '#007BFF',
                '--colorCircleText': this.show ? 'red' : 'none',
                '--focusColor': !this.disabled ? '1px solid #0ca0fd' : '1px solid #dbdbdb',
                '--focusShadowBox': !this.disabled // ? "0px 1px 6px #0ca0fd2e"
                    ? 'none'
                    : 'none'
            };
        }
    },
    data: () => ({
        show: false,
        valueMask: {
            decimal: ',',
            masked: false,
            precision: 2,
            prefix: '',
            thousands: '.'
        },
        noMask: {
            mask: '*'.repeat(255),
            tokens: {
                '*': { pattern: /./ }
            }
        },
        focus: {
            target: false,
            color: ''
        },
        messageError: ''
    }),
    created() {
        this.valueMask.prefix = this.maskType == 'currency' ? 'R$ ' : '';
    },
    watch: {
        valid: {
            deep: true,
            handler() {
                this.validate();
            }
        }
    }
};
</script>
<style scoped>
.row .input-field input:focus,
input.unit-price:focus,
.input-field textarea:focus,
.input-field input:focus {
    border-bottom: 1px var(--colorInput) solid !important;
    box-shadow: 0 0 0 0 !important;
}
</style>
<style>
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
.textearea-icon {
    margin-top: 10px;
    padding-left: 20px;
}
.textarea-component {
    --input-height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 10px;
}

.textarea-component .text-area {
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    padding-top: 12px;
    padding-left: 16px;
    min-width: 100%;
}
.textarea-component .text-area:focus {
    outline: none;
}
.textarea-component .text-area::placeholder {
    color: #a5a5a5;
    font-size: 14px;
    line-height: 19px;
}
.title-textarea {
    margin-left: 5px;
    margin-bottom: 5px;
    font-size: 14px;
    color: var(--colorCircleText);
}
.icon-font {
    font-size: 12px;
    padding-left: 5px;
    padding-bottom: 1px;
    color: var(--colorCircle);
}
@media screen and (max-width: 1366px) {
    .textarea-component {
        --input-height: 38px;
    }
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 992px) {
}
</style>
